import type { IconSvgObject } from './types';

const LiveStreaming02Icon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.5 8C6.5 9 6 10.5 6 12C6 13.5 6.5 15 7.5 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4.5 6C3 7.5 2 9.5 2 12C2 14.5 3 16.5 4.5 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M16.5 16C17.5 15 18 13.5 18 12C18 10.5 17.5 9 16.5 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M19.5 18C21 16.5 22 14.5 22 12C22 9.5 21 7.5 19.5 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default LiveStreaming02Icon;
